import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { Gap } from '@common/components';

export const ButtonGroup = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return (
    <Gap
      className={clsx('wk-button-group', className)}
      data-testid="wk-button-group"
    >
      {children}
    </Gap>
  );
};
